import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, CardContent, CardHeader, Grid } from '@material-ui/core';
import { SelectValidator, TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useStyles } from './DialogEditEnderecoStyles';
import InputMask from 'react-input-mask';
import { ServiceValues } from '../../../../values/ServiceValues';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { TiposTelefoneValues } from '../../../../values/TipoTelefonesValues';
import MenuItem from '@material-ui/core/MenuItem';


const timeout = ServiceValues.timeout;

function DialogEditTelefone(props) {
  const {
    empresa,
    setEmpresa,
    open,
    setOpen,
    index_telefone,
    setIndex_telefone,
  } = props;
  const [codigoPais, setCodigoPais] = useState('+55');
  const [ddd, setDdd] = useState('');
  const [numeroTelefone, setNumeroTelefone] = useState('');
  const [maskDDD, setMaskDDD] = useState('(99)');
  const [maskTelCel, setMaskTelCel] = useState('9.9999-9999');
  const [tipoTelefone, setTipoTelefone] = useState();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));


  useEffect(() => {
    async function carregarEmpresas() {
      if(index_telefone >= 0 && index_telefone < empresa.telefones.length){
        setDdd(empresa.telefones[index_telefone].ddd);
        setNumeroTelefone(empresa.telefones[index_telefone].telefone);
        setTipoTelefone(empresa.telefones[index_telefone].tipo_telefone);
      }
      else{

      }
    }
    carregarEmpresas();
  }, [index_telefone]);

  function saveTelefone() {
    const novoTelefone = {
      codigo_pais: codigoPais,
      ddd: ddd,
      telefone: numeroTelefone,
      tipo_telefone: tipoTelefone,
      telefone_fixo: tipoTelefone.telefone_fixo
    };
    empresa.telefones[index_telefone] = novoTelefone;
    setEmpresa(empresa);
    setDdd('');
    setNumeroTelefone('');
    setTipoTelefone('');
    setIndex_telefone(-1);
    setOpen(false);
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>

      {index_telefone >= 0 && index_telefone < empresa.telefones.length ?
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth={'md'}
          fullWidth
        >
          <DialogContent>
            <ValidatorForm
              autoComplete="off"
              onSubmit={saveTelefone}
            >

              <CardHeader
                subheader="Informe os seguintes dados para adicionar um telefone"
                title="Telefone"
              />
              <CardContent>
                <Grid
                  container
                  spacing={3}
                >
                  <Grid
                    item
                    md={2}
                    xs={12}
                  >
                    <InputMask
                      mask={maskDDD}
                      value={ddd}
                      onChange={e => setDdd(e.target.value.replace('(', '').replace(')', ''))}
                    >
                      {
                        (inputProps) =>
                          <TextValidator
                            fullWidth
                            label="DDD"
                            helperText="Insira o DDD."
                            margin="dense"
                            name="ddd"
                            onChange={inputProps.onChange}
                            variant="outlined"
                            validators={['required']}
                            errorMessages={['Informe o DDD!']}
                          />
                      }
                    </InputMask>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={12}
                  >
                    <InputMask
                      mask={maskTelCel}
                      value={numeroTelefone}
                      onChange={e => setNumeroTelefone(e.target.value.replace('.', '').replace('-', ''))}
                    >
                      {
                        (inputProps) =>
                          <TextValidator
                            fullWidth
                            label="Número"
                            helperText="Insira a número do telefone."
                            margin="dense"
                            name="telefone"
                            onChange={inputProps.onChange}
                            variant="outlined"
                            validators={['required']}
                            errorMessages={['Informe o número do numeroTelefone!']}
                          />
                      }
                    </InputMask>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={12}
                  >
                    <SelectValidator
                      fullWidth
                      helperText="Insira o tipo de telefone!"
                      label="Tipo de Telefone"
                      margin="dense"
                      name="id_sistema"
                      onChange={e => setTipoTelefone(e.target.value)}
                      value={tipoTelefone}
                      variant="outlined"
                      validators={['required']}
                      errorMessages={['Insira o tipo de telefone!']}
                    >
                      {TiposTelefoneValues.map((tipo, index) => (
                        <MenuItem key={index} value={tipo}>{tipo.label}</MenuItem>
                      ))}

                    </SelectValidator>
                  </Grid>
                </Grid>
              </CardContent>
              <DialogActions>
                <Button
                  color="primary"
                  type="submit"
                  variant="contained"
                >
                  Salvar
                </Button>
              </DialogActions>
            </ValidatorForm>
          </DialogContent>

        </Dialog>
        :
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"ERRO"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Não foi possível carregar as informações para esse endereço
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary" autoFocus>
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      }

    </div>

  );
};

DialogEditTelefone.propTypes = {
  className: PropTypes.string,
  empresa: PropTypes.object.isRequired,
};

export default DialogEditTelefone;


